// libs
import React, { ReactElement } from "react";

// internal libs
import { RouterProps, Router } from "@swiggy-private/core-ui";

// components
import { PaymentModes } from "@payment-client/components/payment-modes";
import { PaymentModesAddNewCard } from "@payment-client/components/payment-modes/components/add-new-card";
import { ManageCard } from "@payment-client/components/payment-modes/components/manage-card";
import { SecureCard } from "@payment-client/components/payment-modes/components/secure-card";
import { RedirectPage } from "@payment-client/components/show-payments/components/redirect-page";
import { ConfirmTransaction } from "@payment-client/components/confirm-transaction";
import { RouteContainer } from "./RouteContainer";
import { LinkWalletWithNumber } from "@payment-client/components/show-payments/components/link-wallet-with-number";
import { VerifyWalletLinkOTP } from "@payment-client/components/show-payments/components/verify-wallet-link-otp";
import { LinkWalletContextProvider } from "@payment-client/components/show-payments/components/link-wallet-context-provider";
import { AddMoneyAndDelinkWallet } from "@payment-client/components/payment-modes/components/add-money-and-delink-wallet";
import LinkPaylaterFullPage from "@payment-client/components/show-payments/components/link-paylater/link-full-page-view/LinkFullPage";
import { PaymentLinkPayLater } from "@payment-client/components/show-payments/components/link-paylater";
import { PennyTxnStatusPoller } from "@payment-client/components/penny-txn-status-poller";

// constants
import { CheckoutRoute } from "@swiggy-private/checkout-core";

//deps
import { RouteProps as RoutePropsLinkWallet } from "@payment-client/interfaces/Router";
import { LinkPayLaterWithNumber } from "@payment-client/components/show-payments/components/link-paylater-with-number";

export type PaymentModesRouterProps = Omit<RouterProps<CheckoutRoute>, "children">;

export function PaymentModesRouter(props: PaymentModesRouterProps): ReactElement {
    const outInRoutes = [CheckoutRoute.CONFIRM_TRANSACTION, CheckoutRoute.PENNY_TXN_STATUS_POLLER];
    return (
        <Router {...props} container={RouteContainer} nonOverlappingTransitionRoutes={outInRoutes}>
            <PaymentModes name={CheckoutRoute.PAYMENT_MODES_INDEX}>
                <PaymentModesAddNewCard name={CheckoutRoute.PAYMENT_MODES_ADD_NEW_CARD} />
                <ManageCard name={CheckoutRoute.MANAGE_CARD} />
                <SecureCard name={CheckoutRoute.SECURE_CARD} />
            </PaymentModes>
            <LinkWalletContextProvider<RoutePropsLinkWallet> name={CheckoutRoute.LINK_WALLET_INDEX}>
                <LinkWalletWithNumber isPaymentModeRoute name={CheckoutRoute.PAYMENT_MODES_LINK_WALLET_WITH_NUMBER} />
                <VerifyWalletLinkOTP isPaymentModeRoute name={CheckoutRoute.PAYMENT_MODES_VERIFY_WALLET_LINK_OTP} />
            </LinkWalletContextProvider>
            <LinkPaylaterFullPage isPaymentModeRoute name={CheckoutRoute.PAYLATER_LINKING_CONFIRMATION} />
            <PaymentLinkPayLater isPaymentModeRoute name={CheckoutRoute.LINK_PAYLATER} />
            <LinkPayLaterWithNumber name={CheckoutRoute.LINK_PAYLATER_MOBILE} />
            <RedirectPage name={CheckoutRoute.REDIRECT_PAGE} />
            <ConfirmTransaction name={CheckoutRoute.CONFIRM_TRANSACTION} />
            <PennyTxnStatusPoller name={CheckoutRoute.PENNY_TXN_STATUS_POLLER} />
            <AddMoneyAndDelinkWallet name={CheckoutRoute.WALLET_DETAILS} />
        </Router>
    );
}
